import navbarEN from "../routes/navbar/navbar.lang.en";
import navbarES from "../routes/navbar/navbar.lang.es";
import calendarEN from "../routes/calendarCards/calendarCard.lang.en";
import calendarES from "../routes/calendarCards/calendarCard.lang.es";
import profileEN from "../routes/profileAdminCard/profileAdminCard.lang.en";
import profileES from "../routes/profileAdminCard/profileAdminCard.lang.es";
import bookingEN from "../routes/bookingModal/bookingModal.lang.en";
import bookingES from "../routes/bookingModal/bookingModal.lang.es";
import discoverEN from "../routes/discover/discover.lang.en"; 
import discoverES from "../routes/discover/discover.lang.es"; 
import footerEN from "../routes/footer/footer.lang.en";
import footerES from "../routes/footer/footer.lang.es";
import aboutEN from "../routes/footer/about/about.lang.en";
import aboutES from "../routes/footer/about/about.lang.es";
import privacyPolicyEN from "../routes/footer/privacyPolicy/privacyPolicy.lang.en";
import privacyPolicyES from "../routes/footer/privacyPolicy/privacyPolicy.lang.es";
import termsEN from "../routes/footer/termsAndCondtions/termsAndCondtions.lang.en";
import termsES from "../routes/footer/termsAndCondtions/termsAndCondtions.lang.es";
import listShopEN from "../routes/listshop/listShop.lang.en";
import listShopES from "../routes/listshop/listShop.lang.es";
import myBookingsEN from "../routes/myBookingsPage/myBookingsPage.lang.en";
import myBookingsES from "../routes/myBookingsPage/myBookingsPage.lang.es";
import registerEN from "../routes/registerPage/registerPage.lang.en";
import registerES from "../routes/registerPage/registerPage.lang.es";
import registerShopES from "../routes/registerShop/registerShop.lang.es";
import registerShopEN from "../routes/registerShop/registerShop.lang.en";
import shopPageEN from "../routes/shopPage/shopPage.lang.en";
import shopPageES from "../routes/shopPage/shopPage.lang.es";
import signInEN from "../routes/signinPage/signinPage.lang.en";
import signInES from "../routes/signinPage/signinPage.lang.es";
import viewBookingEN from "../routes/viewBooking/viewBooking.lang.en";
import viewBookingES from "../routes/viewBooking/viewBooking.lang.es";
import confirmationCodeEN from "../routes/confirmationCode/confirmationCode.lang.en";
import confirmationCodeES from "../routes/confirmationCode/confirmationCode.lang.es";
import accountEN from "../routes/accountPage/accountPage.lang.en";
import accountES from "../routes/accountPage/accountPage.lang.es";
import registerStaffEN from "../routes/registerStaff/registerStaff.lang.en";
import registerStaffES from "../routes/registerStaff/registerStaff.lang.es";
import { reviewPageEN } from "../routes/reviewPage/reviewPage.lang.en";
import { reviewPageES } from "../routes/reviewPage/reviewPage.lang.es";
import reportReviewEN from "../routes/reportReviewModal/reportReviewModal.lang.en";
import teamPageEN from "../routes/teamPage/teamPage.lang.en";
import teamPageES from "../routes/teamPage/teamPage.lang.es";
import contactSupportEN from "../routes/footer/contactSupport/contactSupport.lang.en";
import contactSupportES from "../routes/footer/contactSupport/contactSupport.lang.es";
import businessLandingES from "../routes/businessLanding/businessLanding.lang.es";
import businessLandingEN from "../routes/businessLanding/businessLanding.lang.en";
import staffPageEN from "../routes/staffPage/staffPage.lang.en";
import staffPageES from "../routes/staffPage/staffPage.lang.es";
import homeLandingEN from "../routes/homeLanding/homeLanding.lang.en";
import homeLandingES from "../routes/homeLanding/homeLanding.lang.es";
import onboardingEN from "../routes/navbar/onboardingProgressBar/onboardingProgressBar.lang.en";
import onboardingES from "../routes/navbar/onboardingProgressBar/onboardingProgressBar.lang.es";
import confirmForgotPasswordES from "../routes/forgotPasswordConfirm/forgotPasswordConfirm.lang.es";
import forgotPasswordES from "../routes/forgotPassword/forgotPassword.lang.es";
import forgotPasswordEN from "../routes/forgotPassword/forgotPassword.lang.en";
import refundPolicyEN from "../routes/footer/refundPolicy/refundPolicy.lang.en";
import confirmForgotPasswordEN from "../routes/forgotPasswordConfirm/forgotPasswordConfirm.lang.en";
import refundPolicyES from "../routes/footer/refundPolicy/refundPolicy.lang.es";
import billingSectionEN from "../routes/billingSection/billingSection.lang.en";
import billingSectionES from "../routes/billingSection/billingSection.lang.es";
import checkoutPageEN from "../routes/checkoutPage/checkoutPage.lang.en";
import checkoutPageES from "../routes/checkoutPage/checkoutPage.lang.es";
import billingEN from "../routes/accountPage/accountBillingPage/accountBillingPage.lang.en";
import billingES from "../routes/accountPage/accountBillingPage/accountBillingPage.lang.es";
import reportReviewES from "../routes/reportReviewModal/reportReviewModal.lang.es";
import profileStaffEN from "../routes/profileStaffCard/profileStaffCard.lang.en";


const translations = {
	en: {
		navbar: navbarEN,
		calendar: calendarEN,
		profile: profileEN,
		profileStaff: profileStaffEN,
		booking: bookingEN,
		discover: discoverEN,
		footer: footerEN,
		about: aboutEN,
		privacy: privacyPolicyEN,
		terms: termsEN,
		listShop: listShopEN,
		myBookings: myBookingsEN,
		register: registerEN,
		registerShop: registerShopEN,
		registerStaff:registerStaffEN,
		shopPage: shopPageEN,
		signIn: signInEN,
		viewBooking: viewBookingEN,
		confirmationCode: confirmationCodeEN,
		account: accountEN,
		review: reviewPageEN,
		reportReview: reportReviewEN,
		billing: billingEN,
		teamPage: teamPageEN,
		contact: contactSupportEN,
		businessLanding: businessLandingEN,
		staffPage:staffPageEN,
		homeLanding: homeLandingEN,
		onboarding: onboardingEN,
		forgotPassword: forgotPasswordEN,
		confirmForgotPassword: confirmForgotPasswordEN,
		refund: refundPolicyEN,
		billingSection: billingSectionEN,
		checkoutPage: checkoutPageEN,
	},
	es: {
		navbar: navbarES,
		calendar: calendarES,
		profile: profileES,
		profileStaff: profileStaffEN,
		booking: bookingES,
		discover: discoverES,
		footer: footerES,
		about: aboutES,
		privacy: privacyPolicyES,
		terms: termsES,
		listShop: listShopES,
		myBookings: myBookingsES,
		register: registerES,
		registerShop: registerShopES,
		registerStaff:registerStaffES,
		shopPage: shopPageES,
		signIn: signInES,
		viewBooking: viewBookingES,
		confirmationCode: confirmationCodeES,
		account: accountES,
		review: reviewPageES,
		reportReview: reportReviewES,
		billing: billingES,
		teamPage: teamPageES,
		contact: contactSupportES,
		businessLanding: businessLandingES,
		staffPage:staffPageES,
		homeLanding: homeLandingES,
		onboarding: onboardingES,
		forgotPassword: forgotPasswordES,
		confirmForgotPassword: confirmForgotPasswordES,
		refund: refundPolicyES,
		billingSection: billingSectionES,
		checkoutPage: checkoutPageES,
	},
};

export default translations;
